import React from 'react';
import { BasicModal, IBasicModal } from '../BasicModal/BasicModal';
import { useTranslation } from '@wix/yoshi-flow-editor';

type LeaveCollectionModalProps = {
  onSave?: (res?: any) => void;
  onCancel?: () => void;
  isOpen?: boolean;
};

export const LeaveCollectionModal = ({
  isOpen,
  onSave,
  onCancel = () => {},
}: LeaveCollectionModalProps) => {
  const { t } = useTranslation();

  const modalProps = {
    primaryButtonText: t(`LEAVE_COLLECTION_MODAL_CONFIRM_CTA`),
    onPrimaryButtonClick: () => {
      onSave && onSave();
    },
    secondaryButtonText: t(`LEAVE_COLLECTION_MODAL_CANCEL_CTA`),
    onSecondaryButtonClick: onCancel,
    onClose: onCancel,
    title: t(`LEAVE_COLLECTION_MODAL_TITLE`),
    content: t(`LEAVE_COLLECTION_MODAL_CONTENT`),
    isOpen,
  } as IBasicModal;

  return <BasicModal {...modalProps} />;
};
